import { InfoCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export interface IBankDetailsEmptyStateProps {
  onAdd: () => void;
}

export function BankDetailsEmptyState({ onAdd }: IBankDetailsEmptyStateProps) {
  return (
    <div className='rounded-2xl bg-white px-6 py-5'>
      <div className='flex flex-col gap-1'>
        <div className='flex items-center gap-2'>
          <InfoCircleOutlined className='shrink-0 text-base text-gray-500' />
          <p className='m-0 text-sm font-semibold text-black'>
            <FormattedMessage id='applicationDetails.bankDetails.empty.title' />
          </p>
        </div>
        <p className='m-0 text-sm font-normal leading-5 text-gray-500'>
          <FormattedMessage id='applicationDetails.bankDetails.empty.description' />
        </p>
        <Button
          type='default'
          className='mt-4 h-8 w-fit rounded-full border border-gray-200 bg-white px-4 text-sm font-normal text-black shadow-none'
          onClick={onAdd}
        >
          <FormattedMessage id='applicationDetails.bankDetails.empty.addButton' />
        </Button>
      </div>
    </div>
  );
}
